import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1cc8ed44"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "channel-back c-border" }
const _hoisted_2 = { class: "page-default page-media channel" }
const _hoisted_3 = { class: "info" }
const _hoisted_4 = { class: "detail" }
const _hoisted_5 = { class: "name" }
const _hoisted_6 = { class: "code" }
const _hoisted_7 = { class: "desc c-secondary" }
const _hoisted_8 = { class: "btns" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-u131" }, null, -1))
const _hoisted_10 = { class: "counts" }
const _hoisted_11 = { class: "op c-secondary" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "icon i-tool-play",
  style: {"font-size":"20px"}
}, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sp" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-a-lujing133" }, null, -1))
const _hoisted_15 = { class: "filters" }
const _hoisted_16 = ["onClick"]

import fy2Api from '@/api/fy2Api';
import userApi from '@/api/userApi';
import { isMobile } from '@/common/download';
import { setting } from '@/config';
import channel, { State } from '@/store/channels/channel';
import home from '@/store/channels/home';
import i18, { State as I18State } from '@/store/i18';
import user, { State as UserState } from '@/store/user';
import * as filters from '@/views/filters';
import { computed, onMounted, reactive, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const route = useRoute()
const channelId = computed(() => parseInt(route.params.id as string))
const store = useStore()
const leftData = computed(() => store.state[home.name].left)
const data = computed<State>(() => store.state[channel.name])
const userData = computed<UserState>(() => store.state[user.name]);
const i18data = computed<I18State>(() => store.state[i18.name])
const channelLang = computed(() => i18data.value.texts[i18data.value.lang.list[i18data.value.lang.now]].channel)

const temp = reactive({
    loading: false,
    text: '',
    favorite: false,
})

onMounted(() => {
    if (userData.value.info) {
        checkMyFavorite()
    }
    if (isMobile() && setting.first) {
        window.location.href = 'fuyintv://ttlx/bible/' + channelId.value
    }
})

watch(channelId, () => {
    if (userData.value.info) {
        checkMyFavorite()
    }
})

async function checkMyFavorite() {
    if (leftData.value.channels.length > 0) {
        temp.favorite = leftData.value.channels.some((item: any) => item.id == channelId.value)
    }
    temp.favorite = await userApi.isMyChannel(channelId.value)
}

async function onFavorite() {
    if (user.online(store)) {
        temp.favorite = !temp.favorite
        await userApi.setMyChannel(channelId.value)
        let i = leftData.value.channels.findIndex((item: any) => item.id == channelId.value)
        if (temp.favorite) {
            if (i == -1) {
                leftData.value.channels.push(data.value.info)
            }
        } else {
            if (i >= 0) {
                leftData.value.channels.splice(i, 1)
            }
        }
    }
}

function onTypeChange(value: string) {
    data.value.currNav = value
    if (value == 'album') {
        router.push(`/channels/detail/${data.value.info.id}/movies/pages/0.html`)
    } else if (value == 'short_video') {
        router.push(`/channels/detail/${data.value.info.id}/shorts/pages/0.html`)
    } else if (value == 'yuedu') {
        router.push(`/channels/detail/${data.value.info.id}/yuedus/pages/0.html`)
    } else if (value == 'speaker') {
        router.push(`/channels/detail/${data.value.info.id}/speekers/pages/0.html`)
    } else if (value == 'response') {
        router.push(`/channels/detail/${data.value.info.id}/comments/pages/0.html`)
    }
}

async function onLike() {
    await fy2Api.likeChannel(data.value.info.id)
    data.value.info.likes++
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle(_unref(filters).bg(_unref(data).info.thumb))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: "cover",
            style: _normalizeStyle(_unref(filters).bg(_unref(data).info.thumb))
          }, null, 4),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createTextVNode(_toDisplayString(_unref(data).info.title) + " ", 1),
              _createElementVNode("span", _hoisted_6, "@" + _toDisplayString(_unref(data).info.yd_username), 1)
            ]),
            _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(data).info.intro), 1),
            _createElementVNode("div", _hoisted_8, [
              (_unref(temp).favorite)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "btn gray",
                    onClick: onFavorite
                  }, _toDisplayString(_unref(channelLang).unsubscribe), 1))
                : (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    class: "btn",
                    onClick: onFavorite
                  }, [
                    _hoisted_9,
                    _createTextVNode(_toDisplayString(_unref(channelLang).subscribe), 1)
                  ])),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, [
                  _hoisted_12,
                  _createTextVNode(" " + _toDisplayString(_unref(channelLang).play) + " (" + _toDisplayString(_unref(data).info.plays) + ") ", 1)
                ]),
                _hoisted_13,
                _createElementVNode("span", {
                  class: "op c-secondary",
                  onClick: onLike
                }, [
                  _hoisted_14,
                  _createTextVNode(" " + _toDisplayString(_unref(channelLang).good) + " (" + _toDisplayString(_unref(data).info.likes) + ") ", 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).info.menus, (item) => {
            return (_openBlock(), _createElementBlock("a", {
              class: _normalizeClass(["link", { on: _unref(data).currNav == item.page }]),
              onClick: ($event: any) => (onTypeChange(item.page))
            }, _toDisplayString(item.name), 11, _hoisted_16))
          }), 256))
        ])
      ])
    ])
  ], 4))
}
}

})